import { render, staticRenderFns } from "./TemplateTabs.vue?vue&type=template&id=26d0b752&scoped=true&"
import script from "./TemplateTabs.vue?vue&type=script&lang=js&"
export * from "./TemplateTabs.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTabs.vue?vue&type=style&index=0&id=26d0b752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d0b752",
  null
  
)

export default component.exports